module.exports = __webpack_public_path__ + "assets/unionpay.8a10aefc7295216c338ba4e1224627a1.svg";